import React, { useEffect, useState } from 'react'
import { Modal, Tabs, Spin, message, Button } from 'antd'
import { inject, observer } from 'mobx-react'
import { toJS } from 'mobx'
import { TaskInfoList } from '../MissionDetailPage/MissionDetailPageStyled'
import MissionDetailGeneralInfo from '../MissionDetailPage/MissionDetailGeneralInfo'
import MissionDetailUpdate from '../MissionDetailPage/MissionDetailUpdate'
import MissionDetailAssign from '../MissionDetailPage/MissionDetailAssign'
import MissionDetailFiles from '../MissionDetailPage/MissionDetailFiles'
import MissionDetailWorks from '../MissionDetailPage/MissionDetailWorks'
import MissionDetailHistory from './MissionDetailHistory'
import { MissionCreateModal } from '../MissionCreatePage/MissionCreatePageStyled'

const { TabPane } = Tabs

const MissionDetailModalV2 = props => {
  const { isVisible, onCancel, taskCode, taskStore } = props

  const [isLoading, setIsLoading] = useState(false)
  const [taskDetail, setTaskDetail] = useState(null)

  const fetchDetail = async () => {
    try {
      setIsLoading(true)
      await taskStore.getTaskDetail(taskCode)
      setTaskDetail(toJS(taskStore.taskDetail))
    } catch (error) {
      console.log(error)
      message.error(error?.vi || 'Đã có lỗi xảy ra')
      onCancel()
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (isVisible && taskCode) {
      fetchDetail()
    } else {
      setTaskDetail(null)
    }
  }, [isVisible, taskCode])

  return (
    <MissionCreateModal
      title="Chi tiết nhiệm vụ"
      visible={isVisible}
      onCancel={onCancel}
      footer={null}
      width={1000}
      centered>
      <Spin spinning={isLoading}>
        {taskDetail && (
          <div
            style={{
              background: '#fff',
              borderRadius: '12px',
              padding: '24px',
              maxHeight: 'calc(100vh - 180px)',
              overflowY: 'auto',
            }}>
            <h3
              style={{
                fontSize: 16,
                fontWeight: 'bold',
                marginBottom: 16,
              }}>
              Thông tin chung
            </h3>
            <TaskInfoList>
              {taskDetail.contentTask && (
                <MissionDetailGeneralInfo
                  contentTask={taskDetail.contentTask}
                />
              )}
              {taskDetail.resultTask && (
                <MissionDetailUpdate
                  isDetailList
                  missionId={taskCode}
                  files={taskDetail.resultTask?.files || []}
                  resultTask={taskDetail.resultTask}
                  contentTask={taskDetail.contentTask}
                  canUpdateProgress={false}
                  hideActionButtons={true}
                />
              )}
            </TaskInfoList>

            <Tabs defaultActiveKey="1" style={{ marginTop: 24 }}>
              <TabPane tab="Người tham gia" key="1">
                <MissionDetailAssign
                  isDetailList
                  leader={taskDetail.leader}
                  handler={taskDetail.handler}
                  combiner={taskDetail.combiner}
                  capGiao={taskDetail.contentTask?.cap_giao}
                  hideTitleAndBorder
                />
              </TabPane>
              <TabPane tab="Tài liệu đính kèm" key="2">
                <MissionDetailFiles
                  isDetailList
                  missionId={taskCode}
                  files={taskDetail.resultTask?.files || []}
                  resultTask={taskDetail.resultTask}
                  hideTitleAndBorder
                />
              </TabPane>
              <TabPane tab="Danh sách công việc" key="3">
                <MissionDetailWorks
                  isDetailList
                  missionId={taskCode}
                  works={taskDetail.contentTask?.linkedWork}
                  hideTitleAndBorder
                />
              </TabPane>
              <TabPane tab="Lịch sử" key="4">
                <MissionDetailHistory documentCode={taskCode} />
              </TabPane>
            </Tabs>
          </div>
        )}
      </Spin>
    </MissionCreateModal>
  )
}

MissionDetailModalV2.propTypes = {}

export default inject('taskStore')(observer(MissionDetailModalV2))
